import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import { AuthContext } from '../../store/auth-context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import styles from './Comments.module.css'
import useMediaPlayer from '../player/useMediaPlayer';
import { getCookie } from '../../utils/common';
import { conversationFeedbackAPI } from '../../services/api/conversation-feedback';
import { hasSpecialCharacters, removeHtmlTags, replaceHtmlTags } from '../Common/Common';

const DirectComments = ({directComments, setCommentText, getConversationFeedback, id, commentsFilter, type}: any) => {
    const [updateCommentUUID, setUpdateCommentUUID] = useState('')
    const [updateCommentText, setUpdateCommentText] = useState('')
    const [comments, setComments] = useState([])
    const [CommentHasSplChar, setCommentHasSplChar] = useState("");

    const { curTime, setClickedTime } = useMediaPlayer();

    const authCtx = useContext(AuthContext)

    useEffect(() => {
        setComments(directComments)
    }, [directComments])

    useEffect(() => {
        if(commentsFilter) {
            let comments = directComments.filter((comment: any) => comment.is_current_user)
            setComments(comments)
        } else {
            setComments(directComments)
        }
    }, [commentsFilter])

    const onUpdateCommentChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setUpdateCommentText(e.target.value)
    }

    const removeDirectComment = (uuid: string) => {
        const tenantSlug = getCookie('current_tenant')
        conversationFeedbackAPI(tenantSlug).remove?.(uuid)
            .then((response) => {
                console.log(response)
                setCommentText('')
                getConversationFeedback()
            })
            .catch((err: any) => {
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }

    const updateComment = () => {
        setCommentHasSplChar("");
        let updateCmtText = replaceHtmlTags(updateCommentText)
        if(!updateCmtText.trim()) {
            return
        }
        if (hasSpecialCharacters(updateCmtText)) {
            setCommentHasSplChar("Special characters are not allowed in the Comment");
            return;
        }
        const tenantSlug = getCookie('current_tenant')
        const data = {
            comment: updateCmtText,
            time_stamp: Math.round(curTime || 0),
            conversation_id: id,
            is_direct_comment: true,
        }
        conversationFeedbackAPI(tenantSlug).put?.(updateCommentUUID,  data)
            .then((response) => {
                console.log(response)
                setCommentText('')
                updateCommentDetails()
                getConversationFeedback()
            })
            .catch((err: any) => {
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }

    const updateCommentDetails = (uuid: string = '', text: string = '') => {
        setUpdateCommentUUID(uuid)
        setUpdateCommentText(text)
    }

    const directCommentsUI = comments && comments.length > 0 && comments.map(({comment, modified_at, is_current_user, uuid, time_stamp, feedback_by, profile_pic}: any) => {
        comment = removeHtmlTags(comment)
        return  <li key={uuid} className="list-unstyled mt-4 position-relative">
                    <div className="d-flex">
                        <span className={`rounded-circle ${styles.profileIcon}`}>
                            {
                                profile_pic ? 
                                    <img src={profile_pic} className="rounded-circle w-100" alt="..." /> :
                                    <FontAwesomeIcon icon={faUser} />
                            }
                        </span>
                        <div>
                            {
                                type == 'audio' ?
                                    <div className={styles.user}>{feedback_by} 
                                        <span className="text-secondary ps-2">at</span> 
                                        <button onClick={() => setClickedTime(time_stamp)} type="button" className="btn btn-link p-0 ps-1">
                                            {moment.duration(time_stamp, "seconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"})}
                                        </button>
                                    </div> :
                                    null
                            }
                                
                            <div className={`${styles.sectionTitle}`}>
                                {
                                    type != 'audio' && <div className={styles.user}>{feedback_by} </div>
                                }
                                <div>{moment.tz(modified_at, "UTC").format('MMMM D, YYYY z')}</div>
                                {
                                    is_current_user && 
                                    <div className={styles.ListAction}>
                                        <i className="bi bi-three-dots-vertical" data-bs-toggle="dropdown"></i>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <span 
                                                    className={`dropdown-item ${styles.dropdownItem}`}
                                                    
                                                    onClick={() => updateCommentDetails(uuid, comment)}>Edit
                                                </span>
                                            </li>
                                            <li>
                                                <span 
                                                    className={`dropdown-item ${styles.dropdownItem}`}
                                                    onClick={() => removeDirectComment(uuid)}>Delete
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.commentText} mt-2`}>
                        {
                            updateCommentUUID === uuid ? 
                                <>
                                    <textarea
                                        className="d-flex p-3 w-100"
                                        placeholder="Add your comment here ..."
                                        value={updateCommentText}
                                        onChange={onUpdateCommentChangeHandler}
                                    /> 
                                    {
                                        CommentHasSplChar ? 
                                        (
                                            <span className={styles.error}>{CommentHasSplChar}</span>
                                        ) : 
                                        null
                                    }
                                    <div>
                                        <button type="button" className={`btn link-primary float-end ${styles.addCommentBtn}`} onClick={() => updateCommentDetails()}>Cancel</button>
                                        <button type="button" className={`btn link-primary float-end ${styles.addCommentBtn}`} onClick={updateComment}>Update</button>
                                    </div>
                                </>
                                :
                                comment
                        }

                    </div>
                </li>
    })

    return (
        <div>
            { directCommentsUI }
        </div>
    )
}

export default DirectComments
